const BUILTIN_SECTION_KEYS = [
  "header",
  "philosophy",
  "offer",
  "course",
  "experience",
  "videos",
  "feedback",
  "instructor",
  "contact",
  "footer",
];

export const DEFAULT_LAYOUT = {
  sections: BUILTIN_SECTION_KEYS.map((key) => ({
    key,
    type: "builtin",
    enabled: true,
  })),
};

export function resolveLayout(layout) {
  const source =
    Array.isArray(layout?.sections) && layout.sections.length
      ? layout.sections
      : DEFAULT_LAYOUT.sections;
  return source.map((item) => ({
    key: item.key,
    type: item.type === "custom" ? "custom" : "builtin",
    enabled: item.enabled !== false,
    title: item.title || "",
    body: item.body || "",
  }));
}

export function sectionEnabled(layout, key) {
  const sections = resolveLayout(layout);
  const item = sections.find((section) => section.key === key);
  return !item || item.enabled !== false;
}

export function customsAfter(layout, afterKey) {
  const sections = resolveLayout(layout);
  const idx = sections.findIndex((section) => section.key === afterKey);
  if (idx < 0) return [];
  const out = [];
  for (let i = idx + 1; i < sections.length; i += 1) {
    const item = sections[i];
    if (item.type === "custom" && item.enabled !== false) out.push(item);
    else if (item.type !== "custom") break;
  }
  return out;
}
